import { render, staticRenderFns } from "./JournalBeneficiaire.vue?vue&type=template&id=6b8f762f&scoped=true"
import script from "./JournalBeneficiaire.vue?vue&type=script&lang=js"
export * from "./JournalBeneficiaire.vue?vue&type=script&lang=js"
import style0 from "./JournalBeneficiaire.vue?vue&type=style&index=0&id=6b8f762f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8f762f",
  null
  
)

export default component.exports